import { render, staticRenderFns } from "./memberRecommended.vue?vue&type=template&id=29c7d02b&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./memberRecommended.vue?vue&type=script&lang=js&"
export * from "./memberRecommended.vue?vue&type=script&lang=js&"
import style0 from "./memberRecommended.vue?vue&type=style&index=0&id=29c7d02b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c7d02b",
  null
  
)

component.options.__file = "memberRecommended.vue"
export default component.exports